import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../html/element'
import { Icon } from '../../html/icon'
import { ScrollComponent } from '../../scrollComponent'
import { FILTER_TYPE, SCORE_MODE_ID } from '../constant'
import { GroupDisplayScore } from '../filterSetting/components/ScoreLevel/GroupDisplayScore'
import { TYPE_MONEY } from '../filterSetting/constant'
import {
  covertTagDataIndustry,
  handleDisplayScore,
} from '../filterSetting/helper'
import { changeDataSettingNoHandle, changeParamsSetting } from '../store/slice'
import {
  resetBusinessAge,
  selectListSelectedBusinessAge,
} from '../store/sliceBusinessAge'
import {
  resetBusinessSize,
  selectListSelectedBusinessSize,
} from '../store/sliceBusinessSize'
import { resetIndustry, selectIndustry } from '../store/sliceIndustry'
import {
  resetPortfolio,
  selectDataPortfolioAll,
  selectIsAllCheck,
  selectListSelected,
  selectListSelectedCompanyExclude,
} from '../store/slicePortfolio'
import {
  resetStoreProvince,
  selectListSelectedProvince,
} from '../store/sliceProvince'
import {
  resetStoreScoreLevel,
  selectDataScoreLevelRange,
  selectScore,
} from '../store/sliceScoreLevel'
import { getTotalCompanyBySetting } from '../store/sliceTotalCompanies'
import { GroupContentFilter } from './GroupContentFilter'
import classes from './index.module.scss'

export const FilterDisplay = ({ filterType, onClickFilter }) => {
  const dispatch = useDispatch()

  const total = useSelector(getTotalCompanyBySetting)
  const listParentChecked = useSelector(selectIndustry('listParentChecked'))
  const data = useSelector(selectIndustry('industryVSICById'))
  const isAll = useSelector(selectIsAllCheck)
  const listSelectedPort = useSelector(selectListSelected)
  const listSelectedProvince = useSelector(selectListSelectedProvince)
  const listSelectedIndustry = covertTagDataIndustry(data, listParentChecked)
  const listSelectedBusinessAge = useSelector(selectListSelectedBusinessAge)
  const listSelectedBusinessSize = useSelector(selectListSelectedBusinessSize)
  const listIdsSelectedCompany = useSelector(selectListSelectedCompanyExclude)

  const listAllIdPort = useSelector(selectDataPortfolioAll)

  const [isOpen, setIsOpen] = useState(false)

  //display Score
  const scoreRange = useSelector(selectDataScoreLevelRange)

  const scoreCreditCurrent = useSelector(
    selectScore(['creditScore', 'current']),
  )
  const scoreCreditPrev = useSelector(selectScore(['creditScore', 'previous']))
  const scorePerformanceCurrent = useSelector(
    selectScore(['performanceScore', 'current']),
  )
  const scorePerformancePrev = useSelector(
    selectScore(['performanceScore', 'previous']),
  )
  const displayCreditCurrent = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.CORPORATE_RISK],
    scoreCreditCurrent,
  )
  const displayCreditPrev = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.CORPORATE_RISK],
    scoreCreditPrev,
  )
  const displayPerformanceCurrent = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.PERFORMANCE],
    scorePerformanceCurrent,
  )
  const displayPerformancePrev = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.PERFORMANCE],
    scorePerformancePrev,
  )

  const renderWhenStatusAll = () => {
    return <Translate value="library.filterSetting.ALL_ITEMS_SELECT" />
  }

  const toggleOpen = () => {
    setIsOpen((prev) => !prev)
  }

  const handelClearAll = () => {
    dispatch(resetPortfolio())
    dispatch(resetStoreScoreLevel())
    dispatch(resetStoreProvince())
    dispatch(resetIndustry())
    dispatch(resetBusinessSize())
    dispatch(resetBusinessAge())
    dispatch(
      changeParamsSetting({
        portfolioIds: [...listAllIdPort.map((item) => item.value)],
        excludeIds: [],
        scoreLevel: {},
        provinceIds: [],
        industryIds: [],
        currency: TYPE_MONEY[0].value,
        bussinessSizeIds: [],
        bussinessAgeIds: [],
      }),
    )
    dispatch(
      changeDataSettingNoHandle({
        portfolioId: [...listAllIdPort.map((item) => item.value)],
        bussinessAgeId: [],
        bussinessSizeId: [],
        excludeId: [],
        industryId: [],
        provinceId: [],
        scoreLevelObj: {},
        currency: '',
      }),
    )
  }

  return (
    <>
      <Element
        className={classes.filter}
        style={{ backgroundColor: '#F3F3F3' }}
      >
        <div className={`${classes.filterLeft} minW0 flex1`}>
          <Element
            className={classes.btnFilter}
            onClick={onClickFilter}
            style={{
              backgroundColor: '#E5E5E8',
              border: '1px solid #D1D1D1',
            }}
          >
            <Icon className="icon-filter" style={{ fontSize: 10 }} />
            <Element style={{ textTransform: 'capitalize' }}>
              <Translate value="library.filterCompanies.FILTER" />
            </Element>
          </Element>

          {filterType === FILTER_TYPE.LIBRARY ? (
            <Element
              elementName="p"
              style={{
                backgroundColor: '#2C73E8',
                color: '#FFFFFF',
                padding: '2px 8px',
                borderRadius: '2px',
              }}
            >
              <Translate
                value={`library.filterCompanies.${
                  !total || total < 2 ? 'COMPANY' : 'COMPANIES'
                }`}
                count={total}
              />
            </Element>
          ) : (
            <Translate
              value="library.filterCompanies.FILTERED_PORTFOLIO"
              className="fw600"
            />
          )}

          <Element
            className="flex1"
            style={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            (
            {isAll ? (
              <>
                <Translate value="library.selectedFilter.ALL_PORT_SELECT_FILTER" />
              </>
            ) : (
              <>
                <Translate
                  value="library.selectedFilter.PORTFOLIO"
                  count={listSelectedPort.length}
                />{' '}
              </>
            )}
            {!!listIdsSelectedCompany.length && (
              <>
                |{' '}
                <Translate
                  value="library.selectedFilter.EXCLUDE"
                  count={listIdsSelectedCompany.length}
                />{' '}
              </>
            )}
            {(displayCreditCurrent.isShow ||
              displayCreditPrev.isShow ||
              displayPerformanceCurrent.isShow ||
              displayPerformancePrev.isShow) && (
              <>
                | <GroupDisplayScore isShowSidebar />{' '}
              </>
            )}
            {!!listSelectedProvince.length && (
              <>
                |{' '}
                <Translate
                  value="library.selectedFilter.PROVINCE"
                  count={listSelectedProvince.length}
                />{' '}
              </>
            )}
            {!!listSelectedIndustry.length && (
              <>
                |{' '}
                <Translate
                  value="library.selectedFilter.INDUSTRY"
                  count={listSelectedIndustry.length}
                />{' '}
              </>
            )}
            {!!listSelectedBusinessSize.length && (
              <>
                |{' '}
                <Translate
                  value="library.selectedFilter.BUSINESS_SIZE"
                  count={listSelectedBusinessSize.length}
                />{' '}
              </>
            )}
            {!!listSelectedBusinessAge.length && (
              <>
                |{' '}
                <Translate
                  value="library.selectedFilter.YEARS_OF_OPERATION"
                  count={listSelectedBusinessAge.length}
                />{' '}
              </>
            )}
            )
          </Element>
        </div>
        <div className={classes.clearAll}>
          <Element
            elementName="p"
            className="cursorPointer"
            style={{
              color: '#2C73E8',
              whiteSpace: 'nowrap',
              paddingLeft: 12,
            }}
            onClick={handelClearAll}
          >
            <Translate value="library.filterCompanies.CLEAR_ALL" />
          </Element>
          {isOpen ? (
            <Icon
              className="icon-arrow-bottom-bold"
              style={{ fontSize: 8 }}
              onClick={toggleOpen}
            />
          ) : (
            <Icon
              className="icon-arrow-top"
              style={{ fontSize: 8 }}
              onClick={toggleOpen}
            />
          )}
        </div>
      </Element>
      {isOpen && (
        <ScrollComponent autoHeight autoHeightMax={300}>
          <>
            <GroupContentFilter
              data={listSelectedPort}
              title="library.savePortfolio.PORTFOLIO"
              isAll={isAll}
              renderWhenStatusAll={renderWhenStatusAll}
            />
            <GroupContentFilter
              data={listIdsSelectedCompany}
              title="library.filterSetting.EXCLUDE"
            />
            <GroupDisplayScore isShowTable />
            <GroupContentFilter
              data={listSelectedProvince}
              title="library.filterSetting.PROVINCE"
            />
            <GroupContentFilter
              data={listSelectedIndustry}
              title="library.filterSetting.INDUSTRY"
            />
            <GroupContentFilter
              data={listSelectedBusinessSize}
              title="library.filterSetting.BUSINESS_SIZE"
            />
            <GroupContentFilter
              data={listSelectedBusinessAge}
              title="library.filterSetting.YEARS_OF_OPERATION"
            />
          </>
        </ScrollComponent>
      )}
    </>
  )
}
